import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Autocomplete from 'react-autocomplete';
import PulpoField from '../../../../../pulpo_visualizer/fields';
import fieldstyles from '../../../../../pulpo_visualizer/fields/fields.module.scss';
import FormattedMessageWithClass from '../../../../../components/formattedMessageWithClass';
import styles from './fixedfields.module.scss';

class FixedFields extends Component {
  state = {
    currentAirport: undefined
  }

  handleAirportChange = (e) => {
    const { handleSearchForAirport } = this.props;
    this.setState({ currentAirport: e.target.value });
    if ((e.target.value.length%3 === 0 || e.target.value.length === 4)) {
      handleSearchForAirport(e.target.value);
    }
  }

  handleAirportAutocompleteSelect = (val) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;
    this.setState({ currentAirport: val });
    handleAnswerChanged('info', val, 'deptAirport');
    handleFieldErrorChanged('deptAirport', false);
  }

  render() {
    const { currentAirport } = this.state;
    const {
      handleAnswerChanged,
      showFormErrors,
      handleFieldErrorChanged,
      info, aircraftsList,
      airports_data,
      gateListData
    } = this.props;
    return (
      <>
        <div className={styles.float}>
          <div className={styles.column}>
            <PulpoField key="flight_number" id="flight_number" type="string"
              translationID="workorder.create.flt" isRequired
              className={styles.fullInput} title="FLT #"
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.flight_number}
              showFieldErrors={showFormErrors} handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          <div className={styles.column}>
            <PulpoField key="to_gate" id="to_gate" type="select"
              title="Requested Gate" isRequired
              translationID="gate.form.requested_gate"
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.to_gate}
              values={gateListData?.map(item => ({ key: item.gate_number, value: item.gate_number }))}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
        </div>
        <div className={styles.float}>
          <div className={styles.column}>
            <div className={fieldstyles.field}>
              <span>
              <small style={{ color: 'red', marginRight: '3px' }}>*</small>
              <FormattedMessageWithClass
                className={fieldstyles.title} id="gate.form.dept_airport"
                defaultMessage="Departure Airport"
              />
              </span>
              <Autocomplete getItemValue={item => item.name} items={airports_data}
                wrapperStyle={{ position: 'relative' }}
                value={currentAirport || info?.deptAirport}
                onChange={this.handleAirportChange}
                onSelect={this.handleAirportAutocompleteSelect}
                renderMenu={children => (
                  <div className={styles.autocompleteMenu}>
                    {children}
                  </div>
                )}
                renderItem={(item, isHighlighted) => (
                  <div key={item.id} className={`${styles.menuItem} ${isHighlighted && styles.highlighted}`}>
                    {item.name}
                  </div>
                )}
              />
              {showFormErrors && (
                <small>
                  <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="There is an error in this field" />
                </small>
              )}
            </div>
          </div>
          <div className={styles.column}>
            <PulpoField key="arrival_date" id="arrival_date"
              type="datetime" title="Arrival Date" isRequired
              translationID="fodlog.form.arrival_date"
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.arrival_date}
              noDefault fromMeeting
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
        </div>
        <div className={styles.float}>
          <div className={styles.column}>
            <PulpoField key="aircraft" id="aircraft" type="select"
              title="Aircraft" widget={{ type: 'singleSearch' }}
              translationID="fodlog.form.aircraft" isRequired
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.aircraft}
              values={aircraftsList.map((e, index) => ({ key: `${index}`, value: `${e.model}`, text: e.model }))||[]}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          <div className={styles.column}>
            <PulpoField key="arrivalType" id="arrivalType" type="select"
              title="Arrival" isRequired
              translationID="gate.form.arrival_type"
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.arrivalType}
              values={[
                { value: 'Domestic', key: 'domestic' },
                { value: 'International', key: 'international' }
              ]}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
        </div>
        <div className={styles.float}>
        <div className={styles.column}>
          <PulpoField key="in_date" id="in_date" type="datetime"
            title="Requested In-Block Time" isRequired
            translationID="gate.form.to_gate"
            handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info.in_date}
            showFieldErrors={showFormErrors}
            handleFieldErrorChanged={handleFieldErrorChanged}
          />
        </div>
        <div className={styles.column}>
          <PulpoField key="from_date" id="from_date" type="datetime"
            title="Requested Off-Block Time" isRequired
            translationID="gate.form.from_gate"
            handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info?.from_date}
            showFieldErrors={showFormErrors}
            handleFieldErrorChanged={handleFieldErrorChanged}
          />
        </div>
        </div>
        <div className={styles.fullInput}>
          <PulpoField key="remarks" id="remarks" type="string" widget={{ type: 'textarea' }}
            translationID="wildlife.form.remarks"
            title="Remarks"
            handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info.remarks}
            showFieldErrors={showFormErrors} handleFieldErrorChanged={handleFieldErrorChanged}
          />
        </div>
      </>
    );
  }
}

FixedFields.propTypes = {
  info: PropTypes.shape({}).isRequired,
  handleAnswerChanged: PropTypes.func.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool
};

FixedFields.defaultProps = {
  showFormErrors: false
};

export default injectIntl(FixedFields);
